import { createSelector } from 'reselect'

export const selectAdobeCepExtentions = createSelector(
  [ state => state.adobeCepExtentions.extentions ],
  extentions => extentions
)

export const selectActiveCepExtensions = createSelector(
  [ state => state.adobeCepExtentions.activeExtensions ],
  activeExtensions => activeExtensions
)
